var PRIMARY_BORDER_RADIUS = {
  small: '4px',
  medium: '8px',
  large: '32px'
};

export { PRIMARY_BORDER_RADIUS as default };
